<template>
  <div id="user_notifications"> 
    <span class="notify" v-if="$UIPrivilege('dispatching/usermessages')">
        <router-link to="/dispatching/usermessages">
            <b-icon icon="envelope-fill" animation="fade" variant='danger' v-if="unreadMessages" /> 
            <b-icon icon="envelope" v-else /> 
        </router-link>
    </span>
    <span class="notify" v-if="$UIPrivilege('dispatching/events')"> 
        <router-link to="/dispatching/events">
            <b-icon icon="bell-fill" animation="fade" variant='danger' v-if="unreadEvents" /> 
            <b-icon icon="bell" v-else />
        </router-link>
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import events from '@/store/dispatching/events.js'
import moment from 'moment'

let fetchUserMessagesTimer = null

export default {
    data: () => {
        return {
            notificationsExist: true,
        }
    },
    computed: {
        unreadMessages() {
            if (this.eventTimes?.lastMessageTime == undefined) {
                return false;
            }
            return moment(this.eventTimes.lastMessageTime).isAfter(this.messagesViewTime);
        },
        unreadEvents() {
            if (this.eventTimes?.lastEventTime == undefined) {
                return false;
            }
            return moment(this.eventTimes.lastEventTime).isAfter(this.eventsViewTime);
        },
        messageIconClass() {
            let clas = 'mb-0';
            if (!this.unreadMessages) {
                clas += ' inactive';
            }
            return clas;
        },
        eventIconClass() {
            let clas = 'mb-0';
            if (!this.unreadEvents) {
                clas += ' inactive';
            }
            return clas;
        },
        ...mapGetters( {
            newestMessageTime: 'usermessage/newestMessageTime',
        }),
        ...mapState( { 
            eventTimes: state => state.events.eventTimes,
            eventsViewTime: state => state.events.eventsViewTime,
            messagesViewTime: state=> state.events.messagesViewTime
        }) 
        },
        beforeCreate() {
        if( !this.$store.state.events ) {
            this.$store.registerModule("events" , events )
        }
        this.$store.commit("events/setMessagesViewTime")
        this.$store.commit('events/setEventsViewTime')
    },
    mounted() {
        this.clearUserMessageTimer()
        this.fetchUserMessages()
    },
    unmounted() {
        this.clearUserMessageTimer()
    },
    methods: {
        fetchUserMessages() {
           
            this.$store.dispatch("events/updateEventTimes")
            this.clearUserMessageTimer()
            fetchUserMessagesTimer = setTimeout( this.fetchUserMessages , 10000 )
        }, 
        clearUserMessageTimer() {
            if( fetchUserMessagesTimer != null )
                clearTimeout( fetchUserMessagesTimer)
        }
    }
}
</script>

